<template>
  <div class="flex flex-col gap-5 divide-y-1.5">
    <div class="p-3">
      <p class="text-lg font-medium pb-4">Basic Information</p>
      <div v-for="(item, index) in basic" :key="index">
        <div class="flex">
          <p class="w-32 text-gray-400">{{ item.name }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
    </div>
    <div class="p-3">
      <p class="text-lg font-medium pb-4">Skills</p>
      <div v-for="(item, index) in skills" :key="index">
        <div class="flex">
          <p class="w-32 text-gray-400">{{ item.name }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
    </div>
    <div class="flex p-3 gap-5">
      <div v-for="(item, index) in documents" :key="index">
        <div class="flex flex-col gap-1">
          <p class="w-32 text-gray-400">{{ item.name }}</p>
          <p class="bg-gray-200 rounded-full px-2 py-1 text-sm cursor-pointer">
            {{ item.value }} <span class="px-3">&#128206;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  data() {
    return {
      basic: [
        {
          name: "First Name",
          value: "Johnthan",
        },
        {
          name: "Last Name",
          value: "Doe",
        },
        {
          name: "Phone Number",
          value: "+254 700 000 000",
        },
        {
          name: "Email Address",
          value: "john@email.com",
        },
      ],
      skills: [
        {
          name: "Skill 1",
          value: "Skill Name",
        },
        {
          name: "Skill 2",
          value: "Skill Name",
        },
        {
          name: "Skill 3",
          value: "Skill Name",
        },
      ],
      documents: [
        { name: "CV", value: "John Doe cv.pdf " },
        { name: "Cover Letter", value: "John Doe cover leter.pdf " },
      ],
    };
  },
};
</script>